module.exports = __webpack_public_path__ + "static/media/note-regular-green.6b31035a.svg";